import React from 'react';
import { AppConfigValues } from '../../types';

export type ConfigValuesContextData = {
  configValues: AppConfigValues;
};

type Props = {
  children?: React.ReactNode;
  configValues: AppConfigValues;
};

export const ConfigValuesContext = React.createContext<ConfigValuesContextData | null>(null);

export const ConfigValuesProvider: React.FC<Props> = ({ children, configValues }) => {
  const contextValue = React.useMemo(
    (): ConfigValuesContextData => ({
      configValues,
    }),
    [configValues],
  );

  return <ConfigValuesContext.Provider value={contextValue}>{children}</ConfigValuesContext.Provider>;
};
